// Catalogue national des types de pièces (migration 0008, H3-07) et libellés des verdicts.
// Les types locaux d'une collectivité ne sont pas exposés publiquement : le portail propose les
// types nationaux et ceux que la démarche attend.
export const TYPES_PIECE_NATIONAUX: { code: string; libelle: string }[] = [
  { code: 'piece_identite', libelle: 'Pièce d\'identité' },
  { code: 'justificatif_domicile', libelle: 'Justificatif de domicile (valable 90 jours)' },
  { code: 'plan', libelle: 'Plan' },
  { code: 'photo', libelle: 'Photographie' },
  { code: 'extrait_registre_commerce', libelle: 'Extrait du registre du commerce (valable 90 jours)' },
  { code: 'attestation', libelle: 'Attestation' },
  { code: 'autre', libelle: 'Autre pièce' },
];

export function libelleTypePiece(code: string): string {
  return TYPES_PIECE_NATIONAUX.find((t) => t.code === code)?.libelle ?? code.replace(/_/g, ' ');
}

export const LIBELLES_VERDICT: Record<string, { libelle: string; ton: 'neutre' | 'ok' | 'attention' }> = {
  non_examinee: { libelle: 'Pas encore examinée', ton: 'neutre' },
  conforme: { libelle: 'Conforme', ton: 'ok' },
  non_conforme: { libelle: 'Non conforme', ton: 'attention' },
};

/** Formats admis pour une pièce déposée par l'usager (PDF, JPEG, PNG). */
export const FORMATS_PIECE = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
export const TAILLE_MAX_PIECE = 10 * 1024 * 1024;
